import api from "@/services/api";
import { pharmacyDutyErrorMessage } from "@/services/pharmacy-duty-view";

/**
 * @module services/pharmacy-duty
 * @description UC-REG-296 — Cliente de `/pharmacy-duty` (nómina diaria de
 *   farmacias de guardia). Lectura para cualquier usuario de la org;
 *   publicación y baja solo admin.
 */
const pharmacyDutyService = {};

const endpoint = "/pharmacy-duty";

/** @description Opciones comunes: traduce los códigos de error de la API. */
const requestOptions = { getErrorMessage: pharmacyDutyErrorMessage };

/**
 * @description Nómina del día (hoy en el tenant, o la fecha indicada).
 * @param {string} [date] - `AAAA-MM-DD`
 * @returns {Promise<{date: string, published: boolean, notes: string|null, entries: Array}>}
 */
pharmacyDutyService.getToday = function (date) {
  return api
    .get(`${endpoint}/today`, {
      ...requestOptions,
      params: date ? { date } : {},
    })
    .then((res) => res.data);
};

/**
 * @description Nóminas publicadas en un rango (admin).
 * @param {string} from - `AAAA-MM-DD`
 * @param {string} to - `AAAA-MM-DD`
 * @returns {Promise<Array<Object>>}
 */
pharmacyDutyService.query = function (from, to) {
  return api
    .get(endpoint, { ...requestOptions, params: { from, to } })
    .then((res) => res.data);
};

/**
 * @description Publica (crea o reemplaza) la nómina de un día (admin).
 * @param {string} date - `AAAA-MM-DD`
 * @param {{entries: Array<{pharmacy: string, onDuty: boolean, hours?: string}>, notes?: string}} payload
 * @returns {Promise<Object>} nómina publicada
 */
pharmacyDutyService.publish = function (date, payload) {
  return api
    .put(`${endpoint}/${date}`, payload, requestOptions)
    .then((res) => res.data);
};

/**
 * @description Quita la nómina de un día (admin).
 * @param {string} date - `AAAA-MM-DD`
 * @returns {Promise<Object>}
 */
pharmacyDutyService.remove = function (date) {
  return api
    .delete(`${endpoint}/${date}`, requestOptions)
    .then((res) => res.data);
};

export default pharmacyDutyService;
